<template>
    <div class="stdenis-weeklyprograms">
        <div class="white-overlay">
            <div class="container-fluid">
                <header class="stdenis-header pd-t-30">
                    <h2>Weekly Programs</h2>
                    <p>To keep the fire of love of Christ burning in the heart of all our Parishioners, we engage them with the following activities.
                    </p>
                </header>
                <div class="row event-container">
                    <div class="col-lg-4 col-md-12 event">
                        <div class="event-box">
                            <i class="icon ion-md-information-circle-outline"></i>
                            <h4 class="title">
                                <a href="#">Parish Office Hours</a>
                            </h4>
                            <p class="description">
                                Days: Monday - Friday
                                Time: 9:00am -1:00pm

                                Evening: By Appointment </p>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-12 event">
                        <div class="event-box">
                            <i class="icon ion-md-information-circle-outline"></i>
                            <h4 class="title">
                                <a href="#"> Mass Schedule</a>
                            </h4>
                            <p class="description">
                                Sundays: 6:30am, 8:30am, 10:30am, 6:30pm
                            </p>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-12 event">
                        <div class="event-box">
                            <i class="icon ion-md-information-circle-outline"></i>
                            <h4 class="title">
                                <a href="#">Weekday Mass</a>
                            </h4>
                            <p class="description">
                                Morning Masses
                                Mon-Sat: 6:30am

                                Evening Masses
                                Monday, Wednesday, Friday: 6:30pm                            </p>
                        </div>
                    </div>

                    <!-- Second row-->
                    <div class="col-lg-4 col-md-12 event">
                        <div class="event-box">
                            <i class="icon ion-md-information-circle-outline"></i>
                            <h4 class="title">
                                <a href="#">St Raphael's Outstation</a>
                            </h4>
                            <p class="description">
                                Sunday Masses: 7:00am and 9:00am
                            </p>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-12 event">
                        <div class="event-box">
                            <i class="icon ion-md-information-circle-outline"></i>
                            <h4 class="title">
                                <a href="#"> Confessions</a>
                            </h4>
                            <p class="description">
                                Saturday: 5:00pm - 7:00pm
                            </p>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-12 event">
                        <div class="event-box">
                            <i class="icon ion-md-information-circle-outline"></i>
                            <h4 class="title">
                                <a href="#">Infant Baptism</a>
                            </h4>
                            <p class="description">
                                2nd Saturday of the month: 8:00am
                            </p>
                        </div>
                    </div>

                    <!--Third row-->
                    <div class="col-lg-4 col-md-12 event">
                        <div class="event-box">
                            <i class="icon ion-md-information-circle-outline"></i>
                            <h4 class="title">
                                <a href="#">Catechism</a>
                            </h4>
                            <p class="description">
                                Saturday &amp; Sunday: 4:00pm - 6:00pm                            </p>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-12 event">
                        <div class="event-box">
                            <i class="icon ion-md-information-circle-outline"></i>
                            <h4 class="title">
                                <a href="#">Benediction</a>
                            </h4>
                            <p class="description">
                                Sundays by 5:00pm
                            </p>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-12 event">
                        <div class="event-box">
                            <i class="icon ion-md-information-circle-outline"></i>
                            <h4 class="title">
                                <a href="#">Pre-Marriage Course
                                </a>
                            </h4>
                            <p class="description">
                                Sunday: 4:00pm - 6:00pm
                            </p>
                        </div>
                    </div>

                    <!--Forth row-->
                    <div class="col-lg-4 col-md-12 event">
                        <div class="event-box">
                            <i class="icon ion-md-information-circle-outline"></i>
                            <h4 class="title">
                                <a href="#">Weddings</a>
                            </h4>
                            <p class="description">
                                1st, 3rd, 4th, 5th Saturday of the month
                            </p>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-12 event">
                        <div class="event-box">
                            <i class="icon ion-md-information-circle-outline"></i>
                            <h4 class="title">
                                <a href="#">Parish Pastoral Council (PPC)
                                </a>
                            </h4>
                            <p class="description">
                                1st Saturday - Bi-Monthly
                            </p>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-12 event">
                        <div class="event-box">
                            <i class="icon ion-md-information-circle-outline"></i>
                            <h4 class="title">
                                <a href="#">Parish Laity Council</a>
                            </h4>
                            <p class="description">
                                Last Sunday - Every month after 10:30am </p>
                        </div>
                    </div>

                    <div class="col-lg-4 col-md-12 event">
                        <div class="event-box">
                            <i class="icon ion-md-information-circle-outline"></i>
                            <h4 class="title">
                                <a href="#">BCC Meetings</a>
                            </h4>
                            <p class="description">Every Tuesday at all centres</p>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "WeeklyPrograms",
        data(){
            return {}
        },
        created() {
            window.scrollTo(0, 0);
        }
    }
</script>

<style scoped>
    .stdenis-weeklyprograms{
        background-color: #ffffff;
    }
    .event-container{
        padding:30px;
    }
    .event{
        margin-bottom: 20px;
    }
    .event-box{
        background-color: #a6dbff;
        padding:30px;
        border-radius: 5px;
        box-shadow: 0 0 3px rgba(0, 0, 0, 0.15);
        z-index: 2;
        transition: all 0.3s ease 0s;
    }
    .event-box:hover{
        box-shadow: 0px 60px 60px rgba(0,0,0,0.1);
        position: relative;
        z-index: 100;
        transform: translate(0, -10px)
    }
    .event-box i{
        float: left;
        color: #E12993;
        font-size: 36px;
        line-height: 1;
        -webkit-transition: 0.5s;
        transition: 0.5s;
    }
    .event-box .title{
        margin-left: 60px;
        font-weight: 700;
        margin-bottom: 15px;
        font-size: 18px;
    }
    .event-box .description{
        font-size: 14px;
        margin-left: 60px;
        line-height: 24px;
        margin-bottom: 0;
    }
</style>